<!-- 章节练习 -->
<template>
<van-popup v-model="show" class="zjlx-popup list-popup" position="right" :overlay-style="{background: '#fff'}">
    <div class="list-nav">
        <van-icon name="arrow-left" @click="handleClose" />
        <div class="nav-name">章节练习</div>
    </div>
    <!-- <el-scrollbar class="subject-item-box">
        <div class="subject-item" @click="handleChangeActiveSubject(item)" v-for="(item) in tabList" :key="item.code" :class="{active: item.code === activeSubject.code}">{{ item.name }}</div>
    </el-scrollbar> -->
    <div class="subject-box">
        <div class="subject-name">{{ activeSubject.name }}</div>
        <div class="handle" @click="handleOpenChangeSubject">
            <img class="handle-icon" :src="require('@/common/images/mSpecialTopic/change_icon.png')" />
            <div class="handle-label">切换科目</div>
        </div>
    </div>
    <el-scrollbar class="content-scroll">
        <van-collapse v-model="activeSubject.activeNames" @change="handleCollapseChange">
            <van-collapse-item :name="item.sectionid" v-for="(item) in activeSubject.topicinfo.bankinfolist">
                <div slot="title" class="collapse-item-title">
                    <img class="icon unfold" :src="require('@/common/images/mSpecialTopic/unfold_icon.png')" />
                    <img class="icon pack-up" :src="require('@/common/images/mSpecialTopic/pack_up_icon.png')" />
                    <div class="sectionname">{{ item.sectionname }}</div>
                </div>
                <div class="taskinfo-list">
                    <div class="task-item" v-for="(option) in item.taskinfolist" :key="option.taskid">
                        <div class="taskname-data">
                            <div class="taskname">{{ option.taskname }}</div>
                            <div class="data-box" v-if="option.quescount > 0">
                                <div class="progress-box">
                                    <div class="progress" :style="{width: ((option.finishquescount / option.quescount) * 100) + '%'}"></div>
                                </div>
                                <div class="count">{{ option.finishquescount }}/{{ option.quescount }}</div>
                                <div class="rightrate">正确率 {{ option.rightrate }}</div>
                            </div>
                        </div>
                        <div class="item-handle">
                            <div class="lock-btn" v-if="!activeSubject.isjoin" @click="handleBuy">
                                <img class="lock-icon" :src="require('@/common/images/mSpecialTopic/lock_icon.png')" />
                                <div class="label">购买解锁</div>
                            </div>
                            <div v-else>
                                <img class="do-exam-icon" v-if="option.userexamstatus === 0" @click="handleUpdateStartExam(option)" :src="require('@/common/images/mSpecialTopic/do_exam_icon.png')" />
                                <div class="again-exam" v-if="option.userexamstatus === 10" @click="handleUpdateStartExam(option)">重做</div>
                                <div class="continue-exam" v-if="option.userexamstatus === 1" @click="handleContinueExam(option)">继续</div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-collapse-item>
        </van-collapse>
    </el-scrollbar>
    <ChangeSubject ref="changeSubject" @handleSubjectChange="handleSubjectChange"></ChangeSubject>
</van-popup>
</template>

<script>
import specialTopic from '@/common/js/specialTopic.json'
import {getTopicQuesBankInfoV2} from '@/api/specialTopic.js'
import {updateStartExam} from '@/api/questionbank.js'
import {mapActions} from 'vuex'
import ChangeSubject from '../component/changeSubject.vue'
export default {
    data() {
        return {
            show: false,
            activeSubject: {
                code: this.$route.query.subjectcode ? this.$route.query.subjectcode : '',
                activeNames: [],
                topicinfo: {
                    bankid: '',
                    bankinfolist: [],
                    datatype: 0
                }
            },
            tabList: []
        }
    },
    props: {
        subjectList: {
            type: Array,
            required: true,
            default: () => {
                return specialTopic.subject[this.$route.params.examcode]
            }
        }
    },
    components: {
        ChangeSubject
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen() {
            this.show = true
            this.handleInit()
        },
        handleClose() {
            this.show = false
        },
        handleChangeActiveSubject(item) {
            if (item.code !== this.activeSubject.code) {
                this.activeSubject = JSON.parse(JSON.stringify(item))
                if (!this.activeSubject.init) {
                    this.handleGetTopicQuesBankInfoV2()
                }
            }
        },
        handleOpenChangeSubject() {
            this.$refs.changeSubject.handleOpen(this.$route.params.examcode, this.activeSubject.code)
        },
        handleSubjectChange(subjectcode) {
            if (subjectcode !== this.activeSubject.code) {
                this.tabList.some(item => {
                    if (item.code === subjectcode) {
                        this.handleChangeActiveSubject(item)
                        return true
                    }
                })
            }
        },
        handleCollapseChange(activeNames) {
            this.tabList.some(item => {
                if (item.code === this.activeSubject.code) {
                    item.activeNames = activeNames
                    return true
                }
            })
        },
        handleInit() {
            if (!this.activeSubject.init) {
                this.handleGetTopicQuesBankInfoV2()
            }
        },
        handleGetTopicQuesBankInfoV2() {
            let params = {
                examcode: this.$route.params.examcode,
                subjectcode: this.activeSubject.code,
                sectioncode: '0101',
                page: 0,
                pagesize: 0
            }
            this.setLoading(true)
            getTopicQuesBankInfoV2({
                data: params,
                success: data => {
                    this.activeSubject.activeNames = [data.bankinfolist[0].sectionid]
                    this.activeSubject.topicinfo = data
                    this.activeSubject.init = true
                    this.tabList.some(item => {
                        if (item.code === this.activeSubject.code) {
                            item.init = true
                            item.topicinfo = data
                            item.activeNames = [data.bankinfolist[0].sectionid]
                            return true
                        }
                    })
                    this.setLoading(false)
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleBuy() {
            this.$emit('handleBuyTopic', this.activeSubject.code)
        },
        // 开始做题/重新做题
        handleUpdateStartExam(item) {
            this.setLoading(true)
            updateStartExam({
                data: {
                    topiccode: this.$route.params.examcode,
                    subjectcode: this.activeSubject.code,
                    sectioncode: '0101',
                    assetinnerid: this.activeSubject.topicinfo.bankid,
                    taskid: item.taskid,
                    examid: ''
                },
                success: data => {
                    this.setLoading(false)
                    item.userexamstatus = 1
                    item.userexamid = data.data
                    this.$router.push({
                        name: 'MSpecialTopicExam',
                        params: {
                            examsource: 2,
                            examcode: this.$route.params.examcode
                        },
                        query: {
                            examid: data.data,
                            subjectcode: this.activeSubject.code
                        }
                    })
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        // 继续做题/查看解析
        handleContinueExam(item) {
            this.$router.push({
                name: 'MSpecialTopicExam',
                params: {
                    examsource: 2,
                    examcode: this.$route.params.examcode
                },
                query: {
                    examid: item.userexamid,
                    subjectcode: this.activeSubject.code,
                    ischeck: item.userexamstatus === 10 ? 1 : 0
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        
    },
    watch: {
        subjectList: {
            handler(newV) {
                if (newV && newV.length) {
                    let subjectlist = JSON.parse(JSON.stringify(newV))
                    subjectlist.forEach(item => {
                        if (!item.topicinfo) {
                            item.topicinfo = {
                                bankid: '',
                                bankinfolist: [],
                                datatype: 0
                            }
                        }
                    })
                    if (this.activeSubject.code) {
                        let flag = false
                        subjectlist.some(item => {
                            if (item.code === this.activeSubject.code) {
                                this.activeSubject = JSON.parse(JSON.stringify(item))
                                flag = true
                                return true
                            }
                        })
                        if (!flag) {
                            this.activeSubject = JSON.parse(JSON.stringify(subjectlist[0]))
                        }
                    } else {
                        this.activeSubject = JSON.parse(JSON.stringify(subjectlist[0]))
                    }
                    this.tabList = JSON.parse(JSON.stringify(subjectlist))
                }
            },
            deep: true
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.zjlx-popup {
    width: 100vw;
    height: 100vh;
    background: #F8F8F8;
    overflow: hidden;
    .list-nav {
        background: #fff;
        height: 0.88rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .van-icon {
            font-size: 0.4rem;
            position: relative;
            z-index: 12;
        }
        .nav-name {
            position: absolute;
            z-index: 11;
            width: 100%;
            left: 0;
            line-height: 0.88rem;
            text-align: center;
            font-size: 0.34rem;
            color: #333333;
            font-weight: bold;
            box-sizing: border-box;
        }
    }
    .subject-item-box {
        height: 0.8rem;
        .el-scrollbar__view {
            display: flex;
            height: 0.8rem;
            .subject-item {
                padding: 0 0.35rem;
                line-height: 0.8rem;
                font-size: 0.3rem;
                color: #333333;
                white-space: nowrap;
                background: #fff;
                &.active {
                    color: #1D60AD;
                    background: rgba(29,96,173,0.1);
                    font-weight: bold;
                }
            }
        }
    }
    .subject-box {
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.28rem;
        box-sizing: border-box;
        background: #fff;
        .subject-name {
            font-size: 0.3rem;
            color: #333333;
            font-weight: bold;
        }
        .handle {
            display: flex;
            align-items: center;
            .handle-icon {
                width: 0.28rem;
                height: 0.28rem;
                margin-right: 0.08rem;
            }
            .handle-label {
                font-size: 0.26rem;
                color: #666666;
            }
        }
    }
    .content-scroll {
        height: calc(100vh - 0.88rem - 0.8rem);
        .van-collapse {
            padding-top: 0.2rem;
            .van-collapse-item {
                margin-bottom: 0.1rem;
                .van-cell {
                    padding: 0.32rem;
                    box-sizing: border-box;
                    .van-cell__title {
                        .collapse-item-title {
                            display: flex;
                            align-items: center;
                            .icon {
                                width: 0.28rem;
                                height: 0.28rem;
                                margin-right: 0.1rem;
                                &.unfold {
                                    display: block;
                                }
                                &.pack-up {
                                    display: none;
                                }
                            }
                            .sectionname {
                                font-size: 0.28rem;
                                color: #333333;
                                font-weight: bold;
                            }
                        }
                    }
                    &.van-collapse-item__title--expanded {
                        .collapse-item-title {
                            .icon {
                                &.unfold {
                                    display: none;
                                }
                                &.pack-up {
                                    display: block;
                                }
                            }
                        }
                    }
                    .van-icon {
                        display: none;
                    }
                    &::after {
                        display: none;
                    }
                }
                .van-collapse-item__wrapper {
                    .van-collapse-item__content {
                        padding: 0 0.32rem 0 0.72rem;
                        .taskinfo-list {
                            .task-item {
                                display: flex;
                                align-items: center;
                                padding-bottom: 0.32rem;
                                .taskname-data {
                                    flex: 1;
                                    width: 0;
                                    .taskname {
                                        font-size: 0.28rem;
                                        color: #333333;
                                        line-height: 0.4rem;
                                        margin-bottom: 0.1rem;
                                    }
                                    .data-box {
                                        display: flex;
                                        align-items: center;
                                        .progress-box {
                                            width: 0.7rem;
                                            margin-right: 0.24rem;
                                            height: 0.08rem;
                                            background: #F5F5F5;
                                            border-radius: 1rem;
                                            .progress {
                                                height: 0.08rem;
                                                background: #1D60AD;
                                                border-radius: 1rem;
                                            }
                                        }
                                        .count {
                                            font-size: 0.24rem;
                                            line-height: 0.34rem;
                                            color: #999999;
                                            margin-right: 0.2rem;
                                        }
                                        .rightrate {
                                            font-size: 0.24rem;
                                            line-height: 0.34rem;
                                            color: #999999;
                                        }
                                    }
                                }
                                .item-handle {
                                    width: 1rem;
                                    height: 0.54rem;
                                    .lock-btn {
                                        .lock-icon {
                                            width: 0.38rem;
                                            height: 0.38rem;
                                            margin: 0 auto 0.04rem;
                                        }
                                        .label {
                                            font-size: 0.22rem;
                                            color: #999999;
                                            line-height: 0.3rem;
                                        }
                                    }
                                    .do-exam-icon {
                                        width: 0.46rem;
                                        height: 0.46rem;
                                        margin: 0 auto;
                                    }
                                    .again-exam {
                                        width: 0.98rem;
                                        height: 0.54rem;
                                        background: #1D60AD;
                                        border-radius: 1rem;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        color: #fff;
                                        font-size: 0.24rem;
                                    }
                                    .continue-exam {
                                        width: 0.98rem;
                                        height: 0.54rem;
                                        background: #fff;
                                        border: 0.02rem solid #1D60AD;
                                        box-sizing: border-box;
                                        border-radius: 1rem;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        color: #1D60AD;
                                        font-size: 0.24rem;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>